import { render, staticRenderFns } from "./StoriesArticle.vue?vue&type=template&id=114de2c0&scoped=true&"
import script from "./StoriesArticle.vue?vue&type=script&lang=js&"
export * from "./StoriesArticle.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticle.vue?vue&type=style&index=0&id=114de2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114de2c0",
  null
  
)

export default component.exports